import React from 'react';
import styles from './Form.module.css';

export interface FormTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
  className?: string;
}

const FormTextarea: React.FC<FormTextareaProps> = ({ 
  error = false,
  className = '',
  ...props 
}) => {
  return (
    <textarea
      className={`${styles.textarea} ${error ? styles.inputError : ''} ${className}`}
      {...props}
    />
  );
};

export default FormTextarea;

